import React, { Component } from 'react';
import { injectIntl, intlShape } from 'react-intl';
import { fetchBlog, fetchBlogs } from '../redux/actions';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Loader from '../components/Loader';
import './BlogPage.css';
import Helmet from 'react-helmet';
import ReactMarkdown from 'react-markdown'

class BlogPage extends Component {

  componentDidMount() {
    const locale = this.props.intl.locale
    if (!this.props.blog) {
      this.props.fetchBlog(locale)
    }
    if (this.props.blogs.length === 0) {
      this.props.fetchBlogs(locale, 10, 0)
    }
  }

  render() {
    const blog = this.props.blog
    const blogs = this.props.blogs
    if (!blog || blogs.length === 0) {
      // Loading...
      return (
        <div className="blog">
        {!blog && <Loader/>}
        </div>
      );
    }

    return (
      <div className="blog">
        <Helmet>
          <title>{blog.header.heading}</title>
        </Helmet>

        <div className="blog-body" style={blog.header.image.fields.file ? {textShadow: 'black 0 0 5px', backgroundImage: 'url('+blog.header.image.fields.file.url+'?fm=jpg&q=80)'} : null}>
          <Helmet
            meta={[
              {"name": "description", "content": blog.header.lead},
              {"property": "og:description", "content": blog.header.lead}
            ]}
          />
          <div className="container">
            <div>
              {<h1>{blog.header.heading}</h1>}

              <div className="lead">
                <ReactMarkdown source={blog.header.lead} softBreak="br" />
              </div>

              <div className="blog-list">
              {blogs.map(p => {
                return (
                  <div key={p.sys.id} className="blog-card">
                    <Link to={'/blog/' + p.fields.slug}>
                      <span className="blog-image">
                        <img src={p.fields.image.fields.file.url} alt="" />
                      </span>
                      <span className="blog-title">
                        {p.fields.title}
                      </span>
                    </Link>
                  </div>
                );
              })}
              </div>

            </div>
          </div>
        </div>

      </div>
    );
  }
}

BlogPage.propTypes = {
  intl: intlShape.isRequired,
}

const mapStateToProps = state => {
  return {
    blog: state.blog,
    blogs: state.blogs,
  }
};

const mapDispatchToProps = {
  fetchBlog,
  fetchBlogs,
};

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(injectIntl(BlogPage)));



// WEBPACK FOOTER //
// ./src/containers/BlogPage.js